import Icon from '@xunlei/thunder-ui-vue/lib/icon.js';
import Input from '@xunlei/thunder-ui-vue/lib/input.js';

var NAMESPACE = 'td';

var Select = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { staticClass: "td-select", class: { 'is-disabled': _vm.disabled, 'is-top': _vm.position === 'top' }, attrs: { "tabindex": "0" }, on: { "focusin": function focusin($event) {
          _vm.focused = true;
        }, "focusout": function focusout($event) {
          _vm.focused = false;
        } } }, [_c('div', { ref: "select", staticClass: "td-select-group", class: { 'is-choose': _vm.value, 'is-focus': _vm.focused } }, [_vm._t("prefix"), _vm._v(" "), _vm.editable ? _c('td-input', { attrs: { "value": _vm.value, "placeholder": _vm.placeholder }, on: { "input": _vm.handleInput } }) : _c('span', { staticClass: "td-select-group__label", on: { "click": function click($event) {
          _vm.menuVisible = !_vm.menuVisible;
        } } }, [_vm._v(" " + _vm._s(_vm.value || _vm.placeholder) + " ")]), _vm._v(" "), _vm._t("suffix"), _vm._v(" "), _c('a', { staticClass: "td-select__drop", attrs: { "href": "javascript:;" }, on: { "click": function click($event) {
          _vm.menuVisible = !_vm.menuVisible;
        } } }, [_c('td-icon', { attrs: { "type": "arrow-drop" } })], 1), _vm._v(" "), _vm.type === 'file' ? _c('a', { staticClass: "td-select__choose", attrs: { "href": "javascript:;" }, on: { "click": _vm.handleChooseFile } }, [_c('td-icon', { attrs: { "type": "file", "svg": "" } })], 1) : _vm._e()], 2), _vm._v(" "), !_vm.customMenuEnabled ? _c('ul', { directives: [{ name: "show", rawName: "v-show", value: _vm.menuVisible, expression: "menuVisible" }], staticClass: "td-dropdown-menu", class: { 'td-dropdown-menu--select': _vm.markSelected } }, _vm._l(_vm.options, function (option) {
      return _c('li', { key: option, staticClass: "td-dropdown-menu__item", class: option === _vm.value && 'is-selected', on: { "click": function click($event) {
            return _vm.handleInput(option);
          } } }, [_vm._v(" " + _vm._s(option) + " ")]);
    }), 0) : _vm._e()]);
  }, staticRenderFns: [],
  name: NAMESPACE + '-select',

  components: {
    TdIcon: Icon,
    TdInput: Input
  },

  props: {
    value: [Number, String],
    placeholder: String,
    options: Array,
    type: {
      type: String,
      default: 'select'
    },
    customMenuEnabled: Boolean,
    disabled: Boolean,
    editable: Boolean,
    position: String,
    markSelected: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      focused: false,
      menuVisible: false
    };
  },


  watch: {
    focused: function focused(val) {
      this.$emit(val ? 'focus' : 'blur');
    },
    menuVisible: function menuVisible(val) {
      this.$emit(val ? 'menu-show' : 'menu-hide');
    }
  },

  methods: {
    handleChooseFile: function handleChooseFile() {
      this.$emit('choose-file');
    },
    handleDocClick: function handleDocClick(e) {
      if (e.target.closest('.td-select-group') === this.$refs.select) {
        return;
      }
      this.menuVisible = false;
    },
    handleInput: function handleInput(value) {
      this.$emit('input', value);
    }
  },

  mounted: function mounted() {
    document.addEventListener('click', this.handleDocClick);
  },
  destroyed: function destroyed() {
    document.removeEventListener('click', this.handleDocClick);
  }
};

Select.install = function (Vue) {
  Vue.component(Select.name, Select);
};

export default Select;
